import hasWindow from "./hasWindow";
const supportsIdle = hasWindow() && window.requestIdleCallback;
const scheduler = supportsIdle ? window.requestIdleCallback : setTimeout;
const clear = supportsIdle ? window.cancelIdleCallback : clearTimeout;
const scheduleIdleWork = function (fn) {
  let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  //$FlowIssue[incompatible-call] flow doesnt understand we only pass object to requestIdle...
  const handler = scheduler(fn, supportsIdle ? {
    timeout
  } : timeout);
  return () => clear(handler);
};
export default scheduleIdleWork;